import React from "react";
import {
    Typography,
    Box,
} from "@mui/material";
import "../../../css/Content.css";
import "typeface-roboto";
import { TbCopy, TbLink } from "react-icons/tb";
import { useApp } from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";

const CopyLink = ({
    title,
    link,
    containerStyle = {},
    style = {},
    showProtocol = true,
    linkStyle = {},
    showButtonsOnly = false,
}) => {
    const { snackConfig, setSnackConfig } = useApp();
    const navigate = useNavigate();
    const handleCopyClick = async (e) => {
        try {
            // await navigator.clipboard.writeText(link + '?creator_preview=true');
            await navigator.clipboard.writeText(link);
            setSnackConfig({
                open: true,
                message: "Link copied to clipboard",
                timeout: 2000,
            })
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const handleOpenLink = async (e) => {
        navigate('?page=preview')
        // try {
        //     e.preventDefault();
        //     window.open(link + '?creator_preview=true', '_blank');
        // } catch (err) {
        //     console.error('Failed to open link: ', err);
        // }
    };

    const displayLink = showProtocol ? link : link.replace(/^https?:\/\//, '');

    return (
        <Box
            sx={{
                marginBottom: 1.5,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                ...containerStyle
                
            }}>
            {title && (
                <Typography
                    variant="subtitle1"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '16px',
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        color: '#000',
                        marginBottom: '8px'
                    }}
                >
                    {title}
                </Typography>
            )}

            <Box
                // onClick={handleOpenLink}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    padding: '0px 14px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#F6F7FF',
                    },
                    // marginRight: '10px',
                    ...style
                }}
            >
                {/* <TbTableShare fontSize="large" style={{ color: 'var(--brand-color)', fontSize: '20px', marginRight: '10px' }} /> */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        zIndex: 1,
                    }}
                >
                    {!showButtonsOnly && <Typography
                        sx={{
                            flex: 1,
                            color: '#424242',
                            fontSize: '14px',

                            fontFamily: 'Roboto',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            paddingRight: 1,
                            ...linkStyle
                        }}
                        onClick={handleOpenLink}
                    >
                        {displayLink}
                    </Typography>}
                    {/* <TbLink
                            style={{
                                color: 'var(--brand-color)',
                                fontSize: '20px'
                            }}
                            onClick={handleOpenLink}
                        /> */}
                    <TbCopy
                        style={{
                            color: 'var(--brand-color)',
                            fontSize: '20px'
                        }}
                        onClick={handleCopyClick}
                    />
                </Box>
            </Box>

        </Box>
    );
};

export default CopyLink;